import {
  I_DetailTicket,
  I_Ticket,
} from 'app/pages/Account/ListOrder/slice/types';
import { AGENT_ROUTE } from 'app/pages/Agent/constants';
import {
  MATERRIAL_COMBO_TYPE,
  MATERRIAL_EVOUCHER_TYPE,
  MATERRIAL_PARK_TYPE,
} from 'app/pages/Checkout/hooks/useCheckout';
import {
  EvoucherViewType,
  TicketInfo,
} from 'app/pages/NewAccount/layouts/ListTicketLayout';
import { getDetailOrderApi } from 'app/services/checkoutApi';
import * as _ from 'lodash';
import { Dispatch, SetStateAction, useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
const useGetDetailTicket = ({
  screen,
  setIsLoading,
}: {
  screen: string;
  setIsLoading?: Dispatch<SetStateAction<boolean>>;
}) => {
  const [isGetingDetail, setIsGetingDetail] = useState(false);
  const history = useHistory();
  const convertItems = (_items: any[]) => {
    if (_.isEmpty(_items)) return [];
    const newData = _items.map(val => ({
      ...val,
      eventName:
        (val?.park?.name ?? '').toUpperCase() +
        ' | ' +
        (val?.catalog?.name ?? ''),
      serial: val.tickets?.[0]?.sapVerifyCode
        ? val.tickets?.[0]?.sapVerifyCode
        : val.tickets?.[0]?.vgsTicketCode ?? '',
      ticketName: val.show?.name ?? '',
      useDate: val.show?.dateTo?.datetimeDMY ?? '',
      useHour:
        (val.materialType !== MATERRIAL_PARK_TYPE
          ? val.performance?.dateFrom?.time
          : '') ?? '',
      position: val.zone?.name ?? '',
      price:
        val.tickets?.[0]?.unitPrice && !_.isNaN(+val.tickets?.[0]?.unitPrice)
          ? +val.tickets?.[0]?.unitPrice
          : val?.originalPrice ?? val.price ?? 0,
      imgPath: val.show?.image?.original ?? '',
      orgTickets: val.tickets ?? [],
      amount: val.amount ?? 0,
      dataBuyer: val.dataBuyer,
      isComboTicket: val.catalog?.mapVGS === 'S4',
      isComboDiffTicket:
        val?.catalog?.mapVGS === 'S4' && val?.park?.workstationId === 'DIF',
      useDateFrom: val.date?.datetimeDMY ?? '',
      numberAddDays: val.product?.versionB2b || 0,
      selectedDate: val.selectedDate?.datetimeDMY ?? '',
      park: val.park ?? null,
      catalog: val.catalog ?? null,
      show: val.show ?? null,
      performance: val.performance ?? null,
      zone: val.zone ?? null,
      product: val.product ?? null,
      totalPrice: val.totalPrice ?? 0,
      rate: val?.rate ?? 0,
      exchangeCharge: val?.exchangeCharge ?? 0,
      exchangeRate: val?.exchangeRate ?? 0,
      returnCharge: val?.returnCharge ?? 0,
      higherLevelItem: val.higherLevelItem ?? '',
      orderId: val?.id,
      materialType: val?.materialType,
      restaurant: val?.restaurant,
      vgsUsageDate: val?.vgsUsageDate ?? '',
      vgsUsageDateTo: val?.vgsUsageDateTo ?? '',
    }));
    return newData;
  };
  const getDetailTicketData = useCallback(async (orderId: string) => {
    const { data: order } = await getDetailOrderApi(orderId, true);
    const ticketInfo =
      order.items.length > 0
        ? {
            ...order,
            eventName:
              (order.items[0]?.park?.name ?? '').toUpperCase() +
              ' | ' +
              (order.items[0]?.catalog?.name ?? ''),
            serial: order.items[0].tickets?.[0]?.sapVerifyCode
              ? order.items[0].tickets?.[0]?.sapVerifyCode
              : order.items[0].tickets?.[0]?.vgsTicketCode ?? '',
            ticketName: order.items[0].show?.name ?? '',
            useDate: order.items[0].show?.dateTo?.datetimeDMY ?? '',
            useHour:
              (order.items[0].materialType !== MATERRIAL_PARK_TYPE
                ? order.items[0].performance?.dateFrom?.time
                : '') ?? '',
            position: order.items[0]?.zone?.name ?? '',
            price: order.items[0]?.tickets?.[0]?.unitPrice
              ? +order.items[0]?.tickets?.[0]?.unitPrice
              : order.items[0].originalPrice ?? 0,
            imgPath: order.items[0].show?.image?.original ?? '',
            isComboTicket: order.items[0].catalog?.mapVGS === 'S4',
            isComboDiffTicket:
              order.items[0]?.catalog?.mapVGS === 'S4' &&
              order.items[0]?.park?.workstationId === 'DIF',
            useDateFrom: order.items[0].date.datetimeDMY ?? '',
            numberAddDays: order.items[0].product?.versionB2b || 0,
            selectedDate: order.items[0].selectedDate?.datetimeDMY ?? '',
            expiredAt: order.expiredAt ?? '',
            orderdate: order.orderdate ?? '',
          }
        : undefined;
    const tickets = convertItems(order.items);
    const ticketBlocks = convertItems(order.blockItems);
    const vouchers: EvoucherViewType[] = order.giftItems
      .filter(val => val.materialType === MATERRIAL_EVOUCHER_TYPE)
      .flatMap(voucher =>
        (voucher.tickets ?? []).map(val => ({
          productName: voucher.productName ?? '',
          code: val.serialNumber ?? '',
        })),
      );
    const giftsInfo: (TicketInfo & {
      orgTickets: I_DetailTicket[];
      amount: number;
      selectedDate: string;
      higherLevelItem: string;
    })[] = convertItems(
      order.giftItems.filter(
        val =>
          val.materialType !== MATERRIAL_EVOUCHER_TYPE &&
          val.materialType !== MATERRIAL_COMBO_TYPE,
      ),
    );

    const mappedOrder = {
      ...order,
      _id: order.idHash,
      orderInfo: {
        orderId: `${order.id}`,
        amountOfTicket: order.totalTicket ?? 0,
        orderDate: order.orderdate.datetimeDMY,
        totalDiscountValue: order.totalDiscount ?? 0,
        totalPriceValue: order.totalPrice,
        payment: order.payment,
      },
      paymentInfo: {
        customerName: order.name ?? '',
        phoneNumber: order.phone ?? '',
        email: order.email ?? '',
      },
      ticketInfo: ticketInfo,
      ticketsInfo: tickets,
      ticketBlocks: ticketBlocks,
      giftsInfo,
      vouchers,
      orderState: order?.orderState,
      orderIdChanged: order?.orderIdChanged || '',
      refundAmount: order?.refundAmount || 0,
      differenceAmount: order?.differenceAmount || 0,
    };
    return mappedOrder;
  }, []);
  const onClickShowDetail = useCallback(
    async (orderId: string) => {
      setIsGetingDetail(true);
      setIsLoading?.(true);
      try {
        const mappedOrder = await getDetailTicketData(orderId);
        if (mappedOrder.orderType?.value === 'return') {
          if (
            mappedOrder.orderState?.value === 'approved' ||
            mappedOrder.orderState?.value === 'pendingApprove' ||
            mappedOrder.orderState?.value === 'success'
          ) {
            history.push(`/ticket-refund/detail/${mappedOrder._id}`, {
              originPage: screen,
            });
          } else if (mappedOrder.orderState?.value === 'init') {
            history.push(`/ticket-refund/info/${mappedOrder._id}`, {
              prevPage: screen,
            });
          } else if (mappedOrder.orderState?.value === 'cancelled') {
            history.push(`/ticket-refund/detail/${mappedOrder._id}`, {
              prevPage: screen,
              targetTab: 'tab-3',
            });
          }
        } else if (mappedOrder.orderType?.value === 'upgrade') {
          history.push(`/check-tickets/exchange-detail/${mappedOrder._id}`, {
            screen: screen,
          });
        } else {
          history.push(
            screen === '/agent/transaction-history' ||
              screen === '/agent/transaction-history?screen=transaction-list'
              ? '/agent' + AGENT_ROUTE.AGENT_TRANSACTION_HISTORY_ORDER_DETAIL
              : `/order-detail`,
            {
              ticket: mappedOrder,
              screen: screen,
            },
          );
        }
      } catch (error) {
      } finally {
        setIsGetingDetail(false);
        setIsLoading?.(false);
      }
    },
    [getDetailTicketData, history, screen, setIsLoading],
  );

  const getDetailTicket = useCallback(
    async (orderId: string) => {
      setIsGetingDetail(true);
      setIsLoading?.(true);
      try {
        const mappedOrder = await getDetailTicketData(orderId);
        return mappedOrder;
      } catch (error) {
      } finally {
        setIsGetingDetail(false);
        setIsLoading?.(false);
      }
    },
    [getDetailTicketData, setIsLoading],
  );

  return {
    onClickShowDetail,
    isGetingDetail,
    getDetailTicket,
  };
};

export default useGetDetailTicket;
